// // src/pages/treatments/BreastReductionPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const BREAST_REDUCTION_TREATMENT = {
//   slug: "breast-reduction",
//   name: "Breast Reduction Surgery",
//   shortName: "Breast Reduction",
//   tagline: "Lighter. Freer. Confidently You.",
//   heroSubtag:
//     "Save 60–75% on breast reduction surgery. Board-certified plastic surgeons. No waiting list.",
//   description:
//     "Breast reduction surgery (reduction mammaplasty) relieves chronic back, neck and shoulder pain caused by overly large breasts while improving posture, physical activity and self-confidence. India's top plastic surgeons deliver natural, proportionate results using the latest scar-minimising techniques — at a fraction of Western costs.",
//   heroImage:
//     "https://plus.unsplash.com/premium_photo-1718884970260-4c8cb02d7941?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YnJlYXN0LXJlZHVjdGlvbnxlbnwwfHwwfHx8MA%3D%3D",
//   category: "Cosmetic Surgery",
//   badge: "High Satisfaction",
//   accentColor: "pink",
//   costCard: {
//     label: "Complete surgery package",
//     value: "₹1.2L–₹2.5L",
//     compare: "vs. £8,000–£12,000 in the UK",
//     stay: "1 night hospital + 10–14 days recovery",
//     stayCompare: "vs. $8,000–$15,000 in the US",
//   },
//   stats: [
//     { label: "Patient Satisfaction", value: "98%", icon: Award },
//     { label: "Procedures/Year", value: "1,200+", icon: Users },
//     { label: "Years Experience", value: "20+", icon: Shield },
//     { label: "Hospital Stay", value: "1-2 Days", icon: Clock },
//   ],
//   benefits: [
//     "Immediate relief from chronic back, neck and shoulder pain",
//     "Scar-minimising vertical and anchor incision techniques",
//     "Natural, proportionate results tailored to your body frame",
//     "Combined with liposuction for enhanced contouring",
//     "Board-certified plastic surgeons with international fellowship training",
//     "Private, discreet consultation and admission process",
//     "Comprehensive post-op garment and wound care kit included",
//     "Telemedicine follow-up for outstation and international patients",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Consultation & Planning",
//       desc: "Physical examination, measurements, medical history review, and 3D imaging to plan your ideal outcome.",
//       duration: "1-2 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Pre-Op Assessment",
//       desc: "Blood tests, mammogram if required, anaesthesia assessment and marking.",
//       duration: "1 Day",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Surgery",
//       desc: "Removal of excess breast tissue, fat and skin under general anaesthesia. Nipple repositioned to natural position.",
//       duration: "2-4 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Recovery & Follow-Up",
//       desc: "Compression garment worn for 4–6 weeks. Suture removal at day 10–14. Full activity resumed in 4–6 weeks.",
//       duration: "4-6 Weeks",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "Will breast reduction relieve my back and neck pain?",
//       a: "Yes — the vast majority of patients report significant or complete relief from chronic back, neck and shoulder pain within weeks of surgery. Improved posture is also a commonly reported benefit.",
//     },
//     {
//       q: "Will I have visible scars?",
//       a: "All breast reduction techniques leave some scarring, but our surgeons use the latest scar-minimising approaches (vertical or lollipop technique). Scars typically fade significantly over 12–18 months and are easily concealed under clothing and swimwear.",
//     },
//     {
//       q: "Can I breastfeed after breast reduction?",
//       a: "Some women can breastfeed after reduction surgery, but it is not guaranteed. If future breastfeeding is a priority, discuss this with your surgeon before proceeding — technique choice can affect milk duct preservation.",
//     },
//     {
//       q: "What is the minimum age for breast reduction?",
//       a: "Most surgeons recommend waiting until breast development is complete, typically 18–20 years old. Exceptions may be made for younger patients with severe functional symptoms on a case-by-case basis.",
//     },
//     {
//       q: "How much tissue will be removed?",
//       a: "This is customised to your body frame, height and desired cup size. Your surgeon will discuss realistic expectations and the amount of tissue to be removed during your consultation.",
//     },
//     {
//       q: "When can I return to work and exercise?",
//       a: "Desk-based work: 1–2 weeks. Light exercise (walking): 2–3 weeks. Full exercise including upper-body workouts: 6–8 weeks. Your surgeon will tailor this timeline to your individual recovery.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Rajiv Agarwal",
//       specialty: "Plastic & Reconstructive Surgeon",
//       experience: "22 Years",
//       rating: 4.9,
//       reviews: 1840,
//       image: "https://randomuser.me/api/portraits/men/44.jpg",
//       qualifications: "MBBS, MS, MCh (Plastic Surgery), FRCS",
//       hospital: "Apollo Hospitals, Delhi",
//     },
//     {
//       name: "Dr. Priya Bansal",
//       specialty: "Cosmetic & Plastic Surgeon",
//       experience: "18 Years",
//       rating: 4.9,
//       reviews: 2100,
//       image: "https://randomuser.me/api/portraits/women/55.jpg",
//       qualifications: "MBBS, MS (Surgery), DNB (Plastic Surgery)",
//       hospital: "Fortis Memorial, Gurugram",
//     },
//     {
//       name: "Dr. Suresh Menon",
//       specialty: "Board-Certified Plastic Surgeon",
//       experience: "25 Years",
//       rating: 4.8,
//       reviews: 1560,
//       image: "https://randomuser.me/api/portraits/men/67.jpg",
//       qualifications: "MBBS, MCh (Plastic Surgery), Fellowship (USA)",
//       hospital: "Kokilaben Dhirubhai Ambani Hospital, Mumbai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Amina Hassan",
//       age: 32,
//       location: "Nairobi, Kenya",
//       text: "I had been suffering from back pain for over 10 years. After the surgery in Delhi, the pain was gone within two weeks. PaxGrow arranged everything — visa, hotel, airport pickup. I felt completely safe and cared for.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/68.jpg",
//       treatment: "Breast Reduction – Vertical Technique",
//       date: "March 2024",
//     },
//     {
//       name: "Fatima Al-Rashid",
//       age: 27,
//       location: "Lagos, Nigeria",
//       text: "The surgeon was so professional and the results are incredible. My confidence has completely changed. The total cost including flights and hotel was still less than what they quoted me locally.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/34.jpg",
//       treatment: "Breast Reduction + Liposuction Contouring",
//       date: "January 2024",
//     },
//     {
//       name: "Grace Okonkwo",
//       age: 41,
//       location: "Accra, Ghana",
//       text: "I was nervous about travelling to India alone for surgery. Samar from PaxGrow called me personally and walked me through everything. The hospital was world-class and the coordinator was with me every day.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/79.jpg",
//       treatment: "Breast Reduction Surgery",
//       date: "April 2024",
//     },
//   ],
// };

// const BREAST_REDUCTION_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African Patients Choose India for Breast Reduction",
//   whyIndiaReasons: [
//     "Board-certified plastic surgeons with US, UK and European fellowship training — at Indian prices",
//     "JCI and NABH-accredited hospitals with dedicated cosmetic surgery wings and full privacy",
//     "Surgery confirmed within 5–7 days of arrival — no NHS-style waiting lists",
//     "Apollo, Fortis, Kokilaben, Max — ranked among Asia's top cosmetic surgery centres",
//   ],
//   conditionsTitle: "Breast Surgery Procedures We Facilitate",
//   conditions: [
//     "Breast Reduction (Reduction Mammaplasty)",
//     "Breast Lift (Mastopexy)",
//     "Breast Augmentation",
//     "Breast Reconstruction",
//     "Asymmetry Correction",
//     "Gynecomastia (Male Breast Reduction)",
//     "Nipple & Areola Correction",
//   ],
//   stayValue: "1–2 days hospital + 10–14 days recovery in India",
//   costTitle: "Why India for Breast Reduction Surgery?",
//   costRows: [
//     {
//       procedure: "Breast Reduction Surgery",
//       india: "₹1.2L – ₹2.5L",
//       africa: "$5,000–$9,000",
//       ukusa: "$8,000–$15,000",
//     },
//     {
//       procedure: "Breast Lift (Mastopexy)",
//       india: "₹1.0L – ₹2.0L",
//       africa: "$4,500–$8,000",
//       ukusa: "$7,000–$12,000",
//     },
//     {
//       procedure: "Breast Reduction + Liposuction",
//       india: "₹1.8L – ₹3.2L",
//       africa: "$7,000–$12,000",
//       ukusa: "$12,000–$20,000",
//     },
//   ],
// };

// const BreastReductionPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={BREAST_REDUCTION_TREATMENT}
//       paxgrowData={BREAST_REDUCTION_PAXGROW}
//     />
//   );
// };

// export default BreastReductionPage;


// src/pages/treatments/BreastReductionPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const BREAST_REDUCTION_TREATMENT = {
  slug: "breast-reduction",
  name: "Breast Reduction Surgery",
  shortName: "Breast Reduction",
  tagline: "Lighter. Freer. Confidently You.",
  heroSubtag:
    "Save 60–75% on breast reduction surgery. Board-certified plastic surgeons. No waiting list.",
  description:
    "Breast reduction surgery (reduction mammaplasty) relieves chronic back, neck and shoulder pain caused by overly large breasts while improving posture, physical activity and self-confidence. India's top plastic surgeons deliver natural, proportionate results using the latest scar-minimising techniques — at a fraction of Western costs.",
  heroImage:
    "https://plus.unsplash.com/premium_photo-1718884970260-4c8cb02d7941?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YnJlYXN0LXJlZHVjdGlvbnxlbnwwfHwwfHx8MA%3D%3D",
  category: "Cosmetic Surgery",
  badge: "High Satisfaction",
  accentColor: "pink",
  costCard: {
    label: "Complete surgery package",
    value: "$1,500–$3,000",
    compare: "vs. $10,000–$15,000 in the UK",
    stay: "1 night hospital + 10–14 days recovery",
    stayCompare: "vs. $8,000–$15,000 in the US",
  },
  stats: [
    { label: "Patient Satisfaction", value: "98%", icon: Award },
    { label: "Procedures/Year", value: "1,200+", icon: Users },
    { label: "Years Experience", value: "20+", icon: Shield },
    { label: "Hospital Stay", value: "1-2 Days", icon: Clock },
  ],
  benefits: [
    "Immediate relief from chronic back, neck and shoulder pain",
    "Scar-minimising vertical and anchor incision techniques",
    "Natural, proportionate results tailored to your body frame",
    "Combined with liposuction for enhanced contouring",
    "Board-certified plastic surgeons with international fellowship training",
    "Private, discreet consultation and admission process",
    "Comprehensive post-op garment and wound care kit included",
    "Telemedicine follow-up for outstation and international patients",
  ],
  procedure: [
    {
      step: "01",
      title: "Consultation & Planning",
      desc: "Physical examination, measurements, medical history review, and 3D imaging to plan your ideal outcome.",
      duration: "1-2 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Pre-Op Assessment",
      desc: "Blood tests, mammogram if required, anaesthesia assessment and marking.",
      duration: "1 Day",
      icon: Activity,
    },
    {
      step: "03",
      title: "Surgery",
      desc: "Removal of excess breast tissue, fat and skin under general anaesthesia. Nipple repositioned to natural position.",
      duration: "2-4 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Recovery & Follow-Up",
      desc: "Compression garment worn for 4–6 weeks. Suture removal at day 10–14. Full activity resumed in 4–6 weeks.",
      duration: "4-6 Weeks",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "Will breast reduction relieve my back and neck pain?",
      a: "Yes — the vast majority of patients report significant or complete relief from chronic back, neck and shoulder pain within weeks of surgery. Improved posture is also a commonly reported benefit.",
    },
    {
      q: "Will I have visible scars?",
      a: "All breast reduction techniques leave some scarring, but our surgeons use the latest scar-minimising approaches (vertical or lollipop technique). Scars typically fade significantly over 12–18 months and are easily concealed under clothing and swimwear.",
    },
    {
      q: "Can I breastfeed after breast reduction?",
      a: "Some women can breastfeed after reduction surgery, but it is not guaranteed. If future breastfeeding is a priority, discuss this with your surgeon before proceeding — technique choice can affect milk duct preservation.",
    },
    {
      q: "What is the minimum age for breast reduction?",
      a: "Most surgeons recommend waiting until breast development is complete, typically 18–20 years old. Exceptions may be made for younger patients with severe functional symptoms on a case-by-case basis.",
    },
    {
      q: "How much tissue will be removed?",
      a: "This is customised to your body frame, height and desired cup size. Your surgeon will discuss realistic expectations and the amount of tissue to be removed during your consultation.",
    },
    {
      q: "When can I return to work and exercise?",
      a: "Desk-based work: 1–2 weeks. Light exercise (walking): 2–3 weeks. Full exercise including upper-body workouts: 6–8 weeks. Your surgeon will tailor this timeline to your individual recovery.",
    },
  ],
  doctors: [
    {
      name: "Dr. Rajiv Agarwal",
      specialty: "Plastic & Reconstructive Surgeon",
      experience: "22 Years",
      rating: 4.9,
      reviews: 1840,
      image: "https://randomuser.me/api/portraits/men/44.jpg",
      qualifications: "MBBS, MS, MCh (Plastic Surgery), FRCS",
      hospital: "Apollo Hospitals, Delhi",
    },
    {
      name: "Dr. Priya Bansal",
      specialty: "Cosmetic & Plastic Surgeon",
      experience: "18 Years",
      rating: 4.9,
      reviews: 2100,
      image: "https://randomuser.me/api/portraits/women/55.jpg",
      qualifications: "MBBS, MS (Surgery), DNB (Plastic Surgery)",
      hospital: "Fortis Memorial, Gurugram",
    },
    {
      name: "Dr. Suresh Menon",
      specialty: "Board-Certified Plastic Surgeon",
      experience: "25 Years",
      rating: 4.8,
      reviews: 1560,
      image: "https://randomuser.me/api/portraits/men/67.jpg",
      qualifications: "MBBS, MCh (Plastic Surgery), Fellowship (USA)",
      hospital: "Kokilaben Dhirubhai Ambani Hospital, Mumbai",
    },
  ],
  testimonials: [
    {
      name: "Amina Hassan",
      age: 32,
      location: "Nairobi, Kenya",
      text: "I had been suffering from back pain for over 10 years. After the surgery in Delhi, the pain was gone within two weeks. PaxGrow arranged everything — visa, hotel, airport pickup. I felt completely safe and cared for.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/68.jpg",
      treatment: "Breast Reduction – Vertical Technique",
      date: "March 2024",
    },
    {
      name: "Fatima Al-Rashid",
      age: 27,
      location: "Lagos, Nigeria",
      text: "The surgeon was so professional and the results are incredible. My confidence has completely changed. The total cost including flights and hotel was still less than what they quoted me locally.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/34.jpg",
      treatment: "Breast Reduction + Liposuction Contouring",
      date: "January 2024",
    },
    {
      name: "Grace Okonkwo",
      age: 41,
      location: "Accra, Ghana",
      text: "I was nervous about travelling to India alone for surgery. Samar from PaxGrow called me personally and walked me through everything. The hospital was world-class and the coordinator was with me every day.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/79.jpg",
      treatment: "Breast Reduction Surgery",
      date: "April 2024",
    },
  ],
};

const BREAST_REDUCTION_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African Patients Choose India for Breast Reduction",
  whyIndiaReasons: [
    "Board-certified plastic surgeons with US, UK and European fellowship training — at Indian prices",
    "JCI and NABH-accredited hospitals with dedicated cosmetic surgery wings and full privacy",
    "Surgery confirmed within 5–7 days of arrival — no NHS-style waiting lists",
    "Apollo, Fortis, Kokilaben, Max — ranked among Asia's top cosmetic surgery centres",
  ],
  conditionsTitle: "Breast Surgery Procedures We Facilitate",
  conditions: [
    "Breast Reduction (Reduction Mammaplasty)",
    "Breast Lift (Mastopexy)",
    "Breast Augmentation",
    "Breast Reconstruction",
    "Asymmetry Correction",
    "Gynecomastia (Male Breast Reduction)",
    "Nipple & Areola Correction",
  ],
  stayValue: "1–2 days hospital + 10–14 days recovery in India",
  costTitle: "Why India for Breast Reduction Surgery?",
  costRows: [
    {
      procedure: "Breast Reduction Surgery",
      india: "$1,500–$3,000",
      africa: "$5,000–$9,000",
      ukusa: "$8,000–$15,000",
    },
    {
      procedure: "Breast Lift (Mastopexy)",
      india: "$1,200–$2,500",
      africa: "$4,500–$8,000",
      ukusa: "$7,000–$12,000",
    },
    {
      procedure: "Breast Reduction + Liposuction",
      india: "$2,200–$3,900",
      africa: "$7,000–$12,000",
      ukusa: "$12,000–$20,000",
    },
  ],
};

const BreastReductionPage = () => {
  return (
    <TreatmentTemplate
      treatment={BREAST_REDUCTION_TREATMENT}
      paxgrowData={BREAST_REDUCTION_PAXGROW}
    />
  );
};

export default BreastReductionPage;